import React from "react";
import { TailSpin } from "react-loader-spinner";

const LoaderSpinner = () => {
  return (
    <>
      <div className="spinnerOverlay">
        <div className="loaderSpinner">
          <TailSpin type="TailSpin" color="#107ff2" height={100} width={100} />
        </div>
      </div>
    </>
  );
};

export default LoaderSpinner;
